// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1893":"2b8c04d3c0005d1c1a76","2921":"bbf8b3ed123332b51276"}[chunkId] + ".js";
};